import { Routes } from '@angular/router';
import { Authority } from '@api/models';
import { AuthComponent } from '@layouts/auth/auth.component';
import { DashboardComponent } from '@layouts/dashboard/dashboard.component';
import { PromoterComponent } from '@layouts/promoter/promoter.component';
import { CompanyEmailComponent } from '@page/manage/company-email/company-email.component';
import { CompanySettingsComponent } from '@page/manage/company-settings/company-settings.component';
import { RedirectComponent } from '@page/redirect/redirect.component';
import { TicketsExportComponent } from '@page/tickets-export/tickets-export.component';
import { AuthGuard } from '@shared/guard/authorization.guard';

export const routes: Routes = [
   {
      path: '',
      component: AuthComponent,
      loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
   },
   {
      path: 'payment',
      loadChildren: () => import('./pages/payment/payment.routes').then((m) => m.routes),
   },
   {
      path: 'redirect',
      pathMatch: 'full',
      canActivate: [AuthGuard],
      component: RedirectComponent,
   },
   {
      path: 'statistics',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/statistics/statistics.module').then((m) => m.StatisticsModule),
   },
   {
      path: 'events',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/events/events.module').then((m) => m.EventsModule),
   },
   {
      path: 'manage',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/manage/manage.module').then((m) => m.ManageModule),
   },
   {
      path: 'tickets',
      loadChildren: () => import('./pages/tickets/tickets.module').then((m) => m.TicketsModule),
   },
   {
      path: 'pickup',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/pickup/pickup.module').then((m) => m.PickupModule),
   },
   {
      path: 'promoter',
      canActivate: [AuthGuard],
      component: PromoterComponent,
      loadChildren: () => import('./pages/promoter/promoter.module').then((m) => m.PromoterModule),
   },
   {
      path: 'users',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/users/users.routes').then((m) => m.routes),
      data: { authorities: [Authority.ManageUsers] },
   },
   {
      path: 'customer',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/customer/customer.module').then((m) => m.CustomerModule),
      data: { authorities: [Authority.CreateUpdateCustomers] },
   },
   {
      path: 'payoff',
      component: DashboardComponent,
      loadChildren: () => import('./pages/payoff/payoff.module').then((m) => m.PayoffModule),
      data: { anyAuthority: [Authority.ManagePayoff, Authority.ViewPayoff, Authority.ViewMyPayoff] },
   },
   {
      path: 'teams',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/teams/teams.routing').then((m) => m.routes),
      data: { authorities: [Authority.ManageTeams] },
   },
   {
      path: 'assistants',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/assistants/assistants.module').then((m) => m.AssistantsModule),
      data: { authorities: [Authority.ManageAssistants] },
   },
   {
      path: 'notes',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/notes/notes.module').then((m) => m.NotesModule),
      data: { authorities: [Authority.ViewNotes] },
   },
   {
      path: 'tickets-export',
      canActivate: [AuthGuard],
      data: { authorities: [Authority.TicketExport] },
      component: DashboardComponent,
      children: [
         {
            path: '',
            pathMatch: 'full',
            component: TicketsExportComponent,
         },
      ],
   },
   {
      path: 'logbook',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      loadChildren: () => import('./pages/logbook/logbook.module').then((m) => m.LogbookModule),
      data: { authorities: [Authority.ViewLogbook] },
   },
   {
      path: 'company-settings',
      component: DashboardComponent,
      canActivate: [AuthGuard],
      data: { authorities: [Authority.UpdateMyCompany] },
      children: [
         {
            path: '',
            pathMatch: 'full',
            component: CompanySettingsComponent,
         },
      ],
   },
   {
      path: 'company-emails',
      component: DashboardComponent,
      canActivate: [AuthGuard],
      data: { authorities: [Authority.UpdateMyCompany] },
      children: [
         {
            path: '',
            pathMatch: 'full',
            component: CompanyEmailComponent,
         },
      ],
   },
];
